export const UrlValidator = /^(ftp|http|https):\/\/[^ "]+$/;
